import { render, staticRenderFns } from "./MonederoCard.vue?vue&type=template&id=69256b69"
import script from "./MonederoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MonederoCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports